import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import './index.css';


import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

import { registerLocale, setDefaultLocale } from "react-datepicker";
import bg from 'date-fns/locale/bg';
import { ToastContainer } from "react-toastify";
import { FirebaseWrapper } from './firebase/Firebase';

const firebaseConfig = {
  apiKey: "AIzaSyB-Ow1ZbeSxmfG8zZm6Ce--cb_0MdyoICo",
  authDomain: "right-rental-33ce7.firebaseapp.com",
  projectId: "right-rental-33ce7",
  storageBucket: "right-rental-33ce7.appspot.com",
  messagingSenderId: "681492868385",
  appId: "1:681492868385:web:781005066efe582cf9e260",
  measurementId: "G-0TQBN4E118"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
export const appFirestore = getFirestore(firebaseApp);
export const appAuth = getAuth();
const analytics = getAnalytics(firebaseApp);

const container = document.getElementById('root')!;
const root = createRoot(container);

registerLocale('bg', bg);
setDefaultLocale('bg');

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <FirebaseWrapper>
        <App />
      </FirebaseWrapper>
    </Provider>
    <ToastContainer />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
